import { reportReducer } from './reportReducer';
import { searchReducer } from './searchReducer';
import { userRolesReducer } from './userRolesReducer';
import { hubReducer } from './hubReducer';
import { selectionReducer } from './selectionReducer';
import { rolodexReducer } from './rolodexReducer';
import { organizationsReducer } from './organizationsReducer';
import { settingsReducer } from './settingsReducer';
import { combineReducers } from 'redux';
import { clearAccessToken } from '../../../services/authentication.service'
import { LOGOUT_USER } from '../actions/actionTypes';
import { streamReducer } from './streamReducer';
import { conversationReducer } from './conversationReducer';
import { smallTalkReducer } from './smallTalkReducer';
import { chatUsersReducer } from './chatUsersReducer';
import {opportunityReducer} from './opportunityReducer';
import { integrationsReducer } from './integrationsReducer';
import { dealInsightsReducer } from './dealInsightsReducer';
import { imageLibraryReducer } from './imageLibraryReducer';
import { contactListReducer } from './contactListReducer';
import { assetReducer } from './assetReducer';
import { myCollectionsReducer } from './myCollectionsReducer';
import { editCollectionReducer } from './editCollectionReducer';
import { backgroundTaskReducer } from './backgroundTaskReducer';
import { externalLibraryReducer } from './externalLibraryReducer';

const appReducer = combineReducers({
  'reports': reportReducer,
  'search' : searchReducer,
  'userRoles': userRolesReducer,
  'rolodex': rolodexReducer,
  'organizations': organizationsReducer,
  'selection': selectionReducer,
  'hub': hubReducer,
  'settings': settingsReducer,
  'stream': streamReducer,
  'conversations': conversationReducer,
  'smallTalk': smallTalkReducer,
  'opportunities': opportunityReducer,
  'dealInsights': dealInsightsReducer,
  'imageLibrary': imageLibraryReducer,
  'externalLibrary': externalLibraryReducer,
  'contactLists':contactListReducer,
  'asset':assetReducer,
  'myCollections': myCollectionsReducer,
  'editCollection': editCollectionReducer,
  'backgroundTasks': backgroundTaskReducer,
  'externalLibrary': externalLibraryReducer,
  'imageLibrary': imageLibraryReducer,
  'chatUser': chatUsersReducer
});

const legacyRootReducer = (state, action) => {
  if (action.type === LOGOUT_USER) {
    state = undefined
    clearAccessToken();
    // IntercomAPI('shutdown');
  }

  return appReducer(state, action)
}

export { legacyRootReducer };